import React, { FunctionComponent } from "react";

import { Site } from "./site";

import { SiteType } from "../types";

export const SiteAccordion: FunctionComponent<{
  data: any | SiteType;
  toDeleteSite: boolean;
}> = ({ data, toDeleteSite }) => (
  <Site isExpanded isNewSite={data.isNewSite} siteId={data.id} toDeleteSite={toDeleteSite} />
);
